'use client';

import axios from 'axios';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import QuizrrLogo from '../../public/Images/QuizrrWhite.svg';

export function PromoSidebar({ isMobile = false, isTabletTop = false, isTabletBottom = false }) {
  const [fetchedExams, setFetchedExams] = useState([]);

  useEffect(() => {
    fetchExams();
  }, []);

  const fetchExams = async () => {
    try {
      const res = await axios.get(`/api/user/profile/allExams`);
      if (res.data && res.data.success && res.data.data && res.data.data.exams) {
        const formattedExams = res.data.data.exams
          .filter((exam) => exam.shortName !== 'VITEEE, MET, SRMJEEE')
          .map((exam) => ({
            name: exam.shortName || exam.title,
            icon: exam.icon,
          }))
          .filter((exam) => exam.icon && exam.name)
          .sort((a, b) => a.position - b.position);

        setFetchedExams(formattedExams);
      }
    } catch (error) {
      console.error('Error fetching exams:', error);
    }
  };

  const examsToDisplay = fetchedExams.length > 0 ? fetchedExams : [];

  if (isMobile) {
    return (
      <div className="text-[#ffffff] text-center flex flex-col justify-center h-full pt-15 relative">
        <div className="absolute inset-0" style={{ backgroundColor: 'transparent' }} />
        <div className="relative z-10 flex flex-col gap-4 px-8">
          <div className="mb-4 md:mb-8">
            <img src={QuizrrLogo || '/placeholder.svg'} alt="Quizrr" className="h-12 w-auto mx-auto" />
          </div>

          <div className="mb-5 md:mb-8">
            <div className="text-lg font-bold leading-tight">
              India's{' '}
              <span className="relative">
                <span className="italic " style={{ color: '#FFF091' }}>
                  Most Relevant
                </span>{' '}
              </span>
              Test Series
              <br />
              Available For
            </div>
          </div>

          <div className="mb-0">
            <div className="relative overflow-hidden">
              <div
                className="absolute inset-y-0 left-0 w-20 z-20"
                style={{
                  background: 'linear-gradient(90deg, #4338ca, rgba(67, 45, 215, 0))',
                }}
              ></div>
              <div
                className="absolute inset-y-0 right-0 w-20 z-20"
                style={{
                  background: 'linear-gradient(270deg, #4338ca, rgba(67, 45, 215, 0))',
                }}
              ></div>
              <motion.div
                className="flex space-x-8"
                animate={{
                  x: [0, -100 * examsToDisplay.length],
                }}
                transition={{
                  x: {
                    repeat: Number.POSITIVE_INFINITY,
                    repeatType: 'loop',
                    duration: 30,
                    ease: 'linear',
                  },
                }}
              >
                {[...examsToDisplay, ...examsToDisplay].map((exam, index) => (
                  <div key={index} className="flex flex-col items-center space-y-1 min-w-[50px]">
                    <div className="w-10 h-10 rounded-lg flex items-center justify-center p-1">
                      <img
                        src={exam.icon || '/placeholder.svg'}
                        alt={exam.name}
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <span className="text-xs font-medium text-center whitespace-nowrap">{exam.name}</span>
                  </div>
                ))}
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isTabletTop) {
    return (
      <div className="text-[#ffffff] text-center relative">
        <div className="absolute inset-0" style={{ backgroundColor: 'transparent' }} />
        <div className="relative z-10">
          {/* Logo */}
          <div className="mb-4">
            <img src={QuizrrLogo || '/placeholder.svg'} alt="Quizrr" className="h-16 w-auto mx-auto" />
          </div>

          {/* Title */}
          <div>
            <div className="text-2xl font-bold leading-tight">
              India's{' '}
              <span className="relative">
                <span className="italic" style={{ color: '#FFF091' }}>
                  Most Relevant
                </span>{' '}
              </span>
              Test Series
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (isTabletBottom) {
    return (
      <div className="text-[#ffffff] text-center relative">
        <div className="absolute inset-0" style={{ backgroundColor: 'transparent' }} />
        <div className="relative z-10">
          <div className="mb-8 space-y-3 text-lg max-w-2xl mx-auto">
            <div className="flex items-center justify-center space-x-3">
              <div className="w-2 h-2 bg-white rounded-full flex-shrink-0" />
              <p>
                <span className="font-semibold">2868 students</span> secured{' '}
                <span className="font-semibold">99+ Percentile</span> in JEE Main 2026
              </p>
            </div>

            <div className="flex items-center justify-center space-x-3">
              <div className="w-2 h-2 bg-white rounded-full flex-shrink-0" />
              <p className="font-light">
                <span className="font-semibold">1 in every 5</span> JEE Main 2025 99 Percentiler is from our platform
              </p>
            </div>

            <div className="flex items-center justify-center space-x-3">
              <div className="w-2 h-2 bg-white rounded-full flex-shrink-0" />
              <p>
                The choice of <span className="font-semibold">Top 1% of the nation</span>
              </p>
            </div>
          </div>

          <div>
            <p className="text-sm font-light mb-4">MOST RELEVANT TEST SERIES AVAILABLE FOR</p>
            <div className="relative overflow-hidden mx-20">
              <div
                className="absolute inset-y-0 left-0 w-20 z-20"
                style={{
                  background: 'linear-gradient(90deg, #4338ca, rgba(67, 45, 215, 0))',
                }}
              ></div>
              <div
                className="absolute inset-y-0 right-0 w-20 z-20"
                style={{
                  background: 'linear-gradient(270deg, #4338ca, rgba(67, 45, 215, 0))',
                }}
              ></div>
              <motion.div
                className="flex space-x-6"
                animate={{
                  x: [0, -100 * examsToDisplay.length],
                }}
                transition={{
                  x: {
                    repeat: Number.POSITIVE_INFINITY,
                    repeatType: 'loop',
                    duration: 30,
                    ease: 'linear',
                  },
                }}
              >
                {[...examsToDisplay, ...examsToDisplay].map((exam, index) => (
                  <div key={index} className="flex flex-col items-center space-y-2 min-w-[60px]">
                    <div className="w-12 h-12 rounded-lg flex items-center justify-center p-1">
                      <img
                        src={exam.icon || '/placeholder.svg'}
                        alt={exam.name}
                        className="w-full h-full object-contain"
                      />
                    </div>
                    <span className="text-xs font-medium text-center whitespace-nowrap">{exam.name}</span>
                  </div>
                ))}
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-[550px] relative overflow-hidden">
      <div
        className="absolute inset-0"
        style={{
          backgroundColor: 'transparent',
        }}
      />

      <div className="relative z-10 flex flex-col justify-center gap-10 px-0 py-10 text-[#ffffff] w-full">
        <div className="">
          <img src={QuizrrLogo || '/placeholder.svg'} alt="Quizrr" className="h-15 w-auto" />
        </div>

        <div className="flex flex-col justify-center space-y-2">
          <div>
            <div className="text-5xl font-bold leading-tight mb-4">
              India's{' '}
              <span className="relative">
                <span className="italic " style={{ color: '#FFF091' }}>
                  Most Relevant
                </span>
                <div className="absolute bottom-0 left-0 w-full h-1 rounded" style={{ backgroundColor: '#FFF091' }} />
              </span>
              <br />
              Test Series
            </div>
          </div>

          <div className="space-y-2 text-lg">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-white rounded-full" />
              <p className="text-lg">
                <span className="font-semibold">2868 students</span> secured{' '}
                <span className="font-semibold">99+ Percentile</span> in JEE Main 2026
              </p>
            </div>

            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-white rounded-full" />
              <p className="text-lg font-light">1 in every 5 JEE Main 2025 99 Percentiler is from our platform</p>
            </div>

            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-white rounded-full" />
              <p className="text-lg">
                The choice of <span className="font-semibold">Top 1% of the nation</span>
              </p>
            </div>
          </div>
        </div>

        <div className="">
          <p className="text-sm font-light mb-3">MOST RELEVANT TEST SERIES AVAILABLE FOR</p>
          <div className="relative overflow-hidden">
            <div
              className="absolute inset-y-0 left-0 w-20 z-20"
              style={{
                background: 'linear-gradient(90deg, #4338ca, rgba(67, 45, 215, 0))',
              }}
            ></div>
            <div
              className="absolute inset-y-0 right-0 w-20 z-20"
              style={{
                background: 'linear-gradient(270deg, #4338ca, rgba(67, 45, 215, 0))',
              }}
            ></div>

            <motion.div
              className="flex space-x-8"
              animate={{
                x: [0, -100 * examsToDisplay.length],
              }}
              transition={{
                x: {
                  repeat: Number.POSITIVE_INFINITY,
                  repeatType: 'loop',
                  duration: 30,
                  ease: 'linear',
                },
              }}
            >
              {[...examsToDisplay, ...examsToDisplay].map((exam, index) => (
                <div key={index} className="flex flex-col items-center space-y-2 min-w-[60px]">
                  <div className="w-12 h-12 rounded-lg flex items-center justify-center p-1">
                    <img
                      src={exam.icon || '/placeholder.svg'}
                      alt={exam.name}
                      className="w-full h-full object-contain"
                    />
                  </div>
                  <span className="text-xs font-medium text-center whitespace-nowrap">{exam.name}</span>
                </div>
              ))}
            </motion.div>
          </div>
        </div>
      </div>
    </div>
  );
}
